import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { RecurrenciesDrawer, FillInvoiceData, formatStructureForNotification } from "../components/invoices";
import { message } from "antd";
import { emit_invoice } from "../services";
import { CircleAnimationCompact } from "../components/loading";
import MassiveEmitionDrawer from "../components/invoices/emition/MassiveEmitionDrawer";

export const EmitInvoices = ({token, user, company, clients}) => {
	const [ invoice, setInvoice ] = useState({});
	const [ loading, setLoading ] = useState(false);

	useEffect(() => {
		const processNotification = async () => {
			if (invoice.email !== undefined) {
				setLoading(true);
	
				try {
					const res = await emit_invoice(
						formatStructureForNotification(token, company, invoice)
					);
					if (res) {
						message.success(res.data);
					}
				} catch (error) {
					message.error(error.response.data);
				} finally {
					setInvoice({});
					setLoading(false);
				}
			}
		};
	
		processNotification();
	}, [invoice]);
	
	useEffect(() => {
		if (clients !== undefined) {
			setLoading(false);
		} else {
			setLoading(true);
		}
	}, [clients]);
	
	return (
		<>
			{loading ? (
				<CircleAnimationCompact />
			) : (
				<FillInvoiceData
					token={token}
					company={company}
					setInvoice={setInvoice}
					invoice={invoice}
					clients={clients}
				/>
			)}
			<RecurrenciesDrawer
				token={token}
				user={user}
				company={company}
				clients={clients}
			/>
			<MassiveEmitionDrawer 
				token={token}
				company={company}
				clients={clients}
			/>
		</>
	);
};

EmitInvoices.propTypes = {
	token: PropTypes.string.isRequired,
	user: PropTypes.object.isRequired,
	company: PropTypes.object.isRequired,	
	clients: PropTypes.array
};
